var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.608,
    height: 15.608,
    viewBox: "0 0 15.608 15.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-upload",
    "data-name": "Icon feather-upload",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365973",
    "data-name": "Path 365973",
    d: "M18.608,22.5v3.135A1.568,1.568,0,0,1,17.04,27.2H6.068A1.568,1.568,0,0,1,4.5,25.635V22.5",
    transform: "translate(-4.5 -13.095)",
    fill: "none",
    stroke: "#2d5794",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365974",
    "data-name": "Path 365974",
    d: "M18.338,8.419,14.419,4.5,10.5,8.419",
    transform: "translate(-7.365 -4.5)",
    fill: "none",
    stroke: "#2d5794",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365975",
    "data-name": "Path 365975",
    d: "M18,4.5v9.405",
    transform: "translate(-10.946 -4.5)",
    fill: "none",
    stroke: "#2d5794",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.30cd27fe4cf689fc5d9d4269ed94778c.svg";
export { ForwardRef as ReactComponent };